import React from 'react'
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import FilledInput from "@mui/material/FilledInput";
import InputAdornment from "@mui/material/InputAdornment";
import { Box, Typography } from "@mui/material";

const formControlSx = { width: 150 };

Price.propTypes = {
  priceFilter: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setPriceFilter: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default function Price({ priceFilter, setPriceFilter, label = "希望金額" }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Typography sx={{ fontWeight: "bold" }}>{label}</Typography>
      <FormControl sx={{ m: 1, width: "25ch", ...formControlSx }} variant="filled">
      <FilledInput
        value={priceFilter?.value ?? ""}
        onChange={(e) =>
          setPriceFilter((prev) => ({ ...(prev ?? {}), value: e.target.value }))
        }
        id="price-input"
        endAdornment={<InputAdornment position="end">万円</InputAdornment>}
        aria-describedby="filled-weight-helper-text"
        inputProps={{ "aria-label": label, inputMode: "numeric" }}
        sx={{
          backgroundColor: "#fff",
          border: "1px solid #d3d3d3",

          "&:before": {
            borderBottom: "none !important",
          },
          "&:after": {
            borderBottom: "none !important",
          },
          "&:hover:not(.Mui-disabled, .Mui-error):before": {
            borderBottom: "none !important",
          },

          "& .MuiFilledInput-input": {
            textAlign: "center",
            padding: "12px 0",
            lineHeight: "24px",
          },
          "&.Mui-focused": {
            boxShadow: "none",
          },
          "& input": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          "&:focus-within": {
            boxShadow: "none !important",
            outline: "none !important",
          },
          "& .MuiFilledInput-root:focus-within": {
            outline: "none",
            boxShadow: "none",
          },
        }}
      />
      </FormControl>
    </Box>
  );
}
